import React, { useEffect, useState } from "react";
import { useAuth } from "../../firebase/auth.tsx";
import { API_BASE_URL } from "../../config.tsx";
import { getHQNameErrors } from "../helpers/helpers.tsx";
import apiFetch from "../helpers/requests";
import { useTranslation } from "react-i18next";

const CreateHQModal = ({ setShowCreateHQModal, handleCreateHQ }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedHQName, setSelectedHQName] = useState("");

  const { t, i18n } = useTranslation();

  const createHeadquarter = async (name: string) => {
    try {
      const userData = await apiFetch(`/createHQ`, {
        method: "POST",
        body: JSON.stringify({ name }),
      });
      return userData;
    } catch (error) {
      console.error("Error creating HQ:", error);
      throw new Error("An error occurred while create HQ");
    }
  };

  const handleCreateHQSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    setFormSubmitted(true);

    if (getHQNameErrors(selectedHQName, t)) {
      return;
    }

    const newHeadquarter = await createHeadquarter(selectedHQName);

    handleCreateHQ(newHeadquarter);
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Create_a_new_headquarter")}
        </div>
        <form onSubmit={handleCreateHQSubmit} className="m-4">
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label
              htmlFor="HQNameInput"
              style={{
                marginLeft: "20px",
                color: "#404040",
                fontWeight: "bold",
              }}
            >
              {t("Headquarter_name")}
            </label>
            <input
              type="text"
              className="form-control"
              id="HQNameInput"
              placeholder={t("Headquarter")}
              value={selectedHQName}
              onChange={(e) => {
                setSelectedHQName(e.target.value);
                setFormSubmitted(false);
              }}
              style={{
                backgroundColor: "#CCCCCC",
                borderRadius: "20px",
                color: "#404040",
                height: "5vh",
                maxHeight: "40px",
                fontSize: "1em",
                paddingLeft: "20px",
              }}
            />
            <label
              htmlFor="HQNameInput"
              style={{
                marginLeft: "20px",
                color: "#A63939",
                fontSize: "0.8em",
                visibility:
                  formSubmitted && getHQNameErrors(selectedHQName, t)
                    ? "visible"
                    : "hidden",
              }}
            >
              {getHQNameErrors(selectedHQName, t)}
            </label>
          </div>

          <div className="button-container">
            <button
              type="button"
              className="buttonCancel btn btn-primary"
              onClick={() => setShowCreateHQModal(false)}
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary buttonAcceptGreen"
              disabled={formSubmitted}
            >
              {t("Create")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateHQModal;
